import * as Actions from './actions'
import {LOCATION_CHANGE, ON_ENTER, SET_LEAVE_WARNING} from './constants'

export type State = WrappedState & Actions.LocationChangePayload
export interface WrappedState {
  leaveWarningMessage: string,
  showLeaveWarning: boolean,
  skipUrls: string[],
}

const initialState: WrappedState = {
  leaveWarningMessage: '',
  showLeaveWarning: false,
  skipUrls: []
}
export const reducer = (state: State = initialState, action: any) => {
  switch (action.type) {
    case ON_ENTER:
      return {
        ...state,
        pathname: action.pathname,
      }
    case LOCATION_CHANGE:
      const fullURL = action.payload.pathname + '?' + action.payload.hash
      if(state && state.skipUrls && state.skipUrls.includes(fullURL)) {
        return {
          ...state,
          ...action.payload,
        }
      } else {
        return {
          ...state,
          ...action.payload,
          leaveWarningMessage: '',
          showLeaveWarning: false,
          skipUrls: [],
        }
      }
      case SET_LEAVE_WARNING:
        return {
          ...state,
          ...action.payload,
          leaveWarningMessage: action.payload.leaveWarningMessage,
          showLeaveWarning: action.payload.leaveWarningMessage !== "" ? true : false,
          skipUrls: action.payload.skipUrls ? action.payload.skipUrls : [],
        }
    default:
      return state
  }
}
